import { AfterViewInit, Directive, ElementRef, inject, OnDestroy } from '@angular/core';

@Directive({ selector: 'dialog[ipmDialog]' })
export class Dialog implements AfterViewInit, OnDestroy {
  private readonly element = inject(ElementRef<HTMLDialogElement>);

  ngAfterViewInit(): void {
    this.element.nativeElement.showModal();
  }

  ngOnDestroy(): void {
    this.element.nativeElement.close();
  }
}